import { createIcon } from '@chakra-ui/react'

const IconExclamationCircle = createIcon({
  displayName: 'IconExclamationCircle',
  viewBox: '0 0 16 16',
  path: (
    <path
      fill="currentColor"
      d="M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 12a.75.75 0 110-1.5.75.75 0 010 1.5zm.75-3.5a.75.75 0 01-1.5 0V4.75a.75.75 0 011.5 0v3.75z"
    />
  )
})

export default IconExclamationCircle
